import {connect} from 'react-redux'
import OutreachDetail from '../components/Outreach/OutreachDetail'

function mapStateToProps(state, props) {
  return {
    browser: state.browser
  }
}

export default connect(mapStateToProps)(OutreachDetail)


// WEBPACK FOOTER //
// ./src/containers/OutreachDetail.js